import { renderPagination } from '../../../components/Pagination/pagination.js';

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.news-story-grid').forEach(block => {

      //////////////////////////////////////
      // DOM REFS
      const grid          = block.querySelector('.grid');
      const cards         = Array.from(block.querySelectorAll('.card'));
      const paginationEl  = block.querySelector('.pagination');
      const perPage       = parseInt(block.dataset.perPage, 10) || 3;
      const total         = cards.length;

      if (!cards.length) return;


      //////////////////////////////////////
      // STATE
      const state = { page: 1 };


      //////////////////////////////////////
      // RENDER
      const render = () => {
        const start = (state.page - 1) * perPage;
        const end   = start + perPage;

        cards.forEach((card, i) => {
          card.style.display = (i >= start && i < end) ? '' : 'none';
        });

        if (paginationEl) {
          renderPagination({
            container:   paginationEl,
            currentPage: state.page,
            totalItems:  total,
            perPage,
            label:       'Stories',
            onPageChange(page) { state.page = page; render(); }
          });
        }
      };


      //////////////////////////////////////
      // INIT
      if (total > perPage) render();

    });

  });

})();
